import { Controller } from "stimulus"

import "select2"
import "select2/dist/css/select2.css"

export default class extends Controller {
  connect() {
    let $this = $(this.element)
    let minimumInputLength = parseInt($this.data('min-input')) || 0
    let isTagging = $this.data('select2-tagging') != undefined
    let allowsClear = $this.data('allows-clear') != undefined
    let ensureLastUser = $this.data('organization-ids-with-only-one-user-left') != undefined
    let width = $this.data('width') || 'resolve'
    $this.select2({
      placeholder: $this.data('placeholder'),
      allowClear: allowsClear,
      minimumInputLength: minimumInputLength,
      tags: isTagging,
      width: width,
      dropdownParent: this.element.closest('[data-defines-presentation-context]'),
    })

    if (ensureLastUser){
      $this.on('select2:unselecting', (e) => {
        if($this.data('organization-ids-with-only-one-user-left').includes(parseInt(e.params.args.data.id))) {
          e.preventDefault();
          
          // Store the event data for later use
          const eventData = e.params.args.data;
          const currentTarget = e.currentTarget;
          
          const confirmEvent = new CustomEvent('confirm', {
            bubbles: true,
            cancelable: true
          });
          
          this.element.dispatchEvent(confirmEvent);
          
          // Use a one-time event listener on the document to catch the confirm click
          const handleConfirm = () => {
            $(eventData.element).prop("selected", false);
            $(currentTarget).trigger("change.select2");
            document.removeEventListener('click', confirmHandler);
          };
          
          const confirmHandler = (event) => {
            if (event.target && event.target.id === 'confirmBtn') {
              handleConfirm();
            }
          };
          
          // Add the event listener to the document with delegation
          document.addEventListener('click', confirmHandler);
        }
      });
    }
  }

  disconnect() {
    $(this.element).select2('destroy')
  }
}